// src/App.js
import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

// Components
import Nav from "./components/Nav";
import Footer from "./components/Footer";
import GA from "./GA";

// Pages
import Home from "./pages/Home";
import AboutPage from "./pages/AboutPage";
import MeetChefsCity from "./pages/MeetChefsCity";   // ⬅️ use the working page
import JoinOurTeam from "./pages/JoinOurTeam";
import Dashboard from "./components/Dashboard/Dashboard";
import Contact from "./pages/Contact";
import ChefDemo from "./pages/ChefDemo";
import ChefOnboarding from "./components/ChefOnboarding";
import HybridDataTest from "./pages/HybridDataTest";
import MobileTest from "./pages/MobileTest";
import OperatorDashboard from "./components/OperatorDashboard/OperatorDashboard";
import OrderNow from "./pages/OrderNow";
import Checkout from "./pages/Checkout";
import OrderConfirmation from "./pages/OrderConfirmation";
import TrackOrder from "./pages/TrackOrder";
import DriverPortal from "./pages/DriverPortal";

// Global styles
import "./styles.css";

export default function App() {
  return (
    <Router>
      <GA />
      <Nav />
      <div className="page-container">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<AboutPage />} />

          {/* Chefs listing (with/without city) */}
          <Route path="/chefs" element={<MeetChefsCity />} />
          <Route path="/chefs/:city" element={<MeetChefsCity />} />

          {/* Chef Demo profile */}
          <Route path="/chef-demo" element={<ChefDemo />} />
          <Route path="/chef-demo/:city" element={<ChefDemo />} />

          <Route path="/join-team" element={<JoinOurTeam />} />
          <Route path="/chef-onboarding" element={<ChefOnboarding />} />
          <Route path="/order-now" element={<OrderNow />} />
          <Route path="/checkout" element={<Checkout />} />
          <Route path="/order-confirmation" element={<OrderConfirmation />} />
          <Route path="/track/:orderNumber" element={<TrackOrder />} />
          <Route path="/track" element={<TrackOrder />} />
          <Route path="/driver" element={<DriverPortal />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/operator" element={<OperatorDashboard />} />
          <Route path="/contact" element={<Contact />} />
          
          {/* Test page for hybrid data system */}
          <Route path="/test-hybrid" element={<HybridDataTest />} />
        <Route path="/mobile-test" element={<MobileTest />} />
        </Routes>
      </div>
      <Footer />
    </Router>
  );
}